'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

var _Media = require('components/Media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Documentary = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Documentary, _React$Component);

  function Documentary(props) {
    (0, _classCallCheck3.default)(this, Documentary);
    return (0, _possibleConstructorReturn3.default)(this, (Documentary.__proto__ || (0, _getPrototypeOf2.default)(Documentary)).call(this, props));
  }

  (0, _createClass3.default)(Documentary, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _props$strings = this.props.strings,
          srcVideo = _props$strings.srcVideo,
          urlSubtitles = _props$strings.urlSubtitles;


      var trackLabel = this.props.currentLanguage === "es" ? "Spanish" : "English";

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 1500, transitionEnter: true, transitionEnterTimeout: 1500, transitionLeave: true, transitionLeaveTimeout: 1500 },
        _react2.default.createElement(
          _reactBodyClassname2.default,
          { className: 'documentary' },
          _react2.default.createElement(_Media.Video, { ref: 'videoCase', sources: [srcVideo],
            subtitles: [{ src: this.context.baseUrl + urlSubtitles, label: trackLabel, lang: this.props.currentLanguage }],
            autoPlay: true,
            activeSubtitle: 0,
            subtitleOn: this.props.currentLanguage === "en" ? true : false,
            isSubtitled: this.props.currentLanguage === "en" ? true : false,
            layout: 'squareLayout',
            icons: {
              sound: _react2.default.createElement('i', { className: 'icon-sound' }),
              mute: _react2.default.createElement('i', { className: 'icon-mute' }),
              togglePlay: _react2.default.createElement('i', { className: 'icon-mute' }),
              subtitles: _react2.default.createElement('i', { className: 'icon-rectangle-subtitle' })
            },
            controls: true,
            width: '100%',
            height: '100%' })
        )
      );
    }
  }]);
  return Documentary;
}(_react2.default.Component), _class2.displayName = 'Documentary', _class2.propTypes = {
  name: _react2.default.PropTypes.string
}, _class2.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp)) || _class);
;

exports.default = (0, _translate2.default)('Documentary')(Documentary);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Documentary/Documentary.js
// module id = 815
// module chunks = 0